import React, { useState } from "react";
import { Modal, Button, Badge, Alert } from "react-bootstrap";
import API from "../../api/api";

export default function EncashmentsModal({
  show,
  handleClose,
  encashment,
  role,
  onSuccess,
}) {
  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState("");

  const handleAction = async (updates) => {
    try {
      setLoading(true);
      setFeedback("");

      const url =
        role === "admin"
          ? `/api/encashments/admin/${encashment._id}`
          : `/api/encashments/${encashment._id}`;

      const method = role === "admin" ? "patch" : "delete";

      if (method === "patch") {
        await API.patch(url, updates, { withCredentials: true });
      } else {
        await API.delete(url, { withCredentials: true });
      }

      setFeedback("Action completed successfully.");
      onSuccess();
      setTimeout(() => {
        handleClose();
      }, 800);
    } catch (err) {
      console.error("Encashment action error:", err);
      setFeedback(
        err.response?.data?.error || "Something went wrong. Try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadge = (status) => {
    const colors = {
      Approved: "success",
      Rejected: "danger",
      Pending: "warning",
    };
    return <Badge bg={colors[status] || "secondary"}>{status}</Badge>;
  };

  const getPaymentBadge = (paymentStatus) => {
    const colors = {
      Paid: "primary",
      Processing: "info",
      Unpaid: "secondary",
    };
    return (
      <Badge bg={colors[paymentStatus] || "secondary"}>{paymentStatus}</Badge>
    );
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Encashment Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {feedback && (
          <Alert
            variant={feedback.includes("successfully") ? "success" : "danger"}
          >
            {feedback}
          </Alert>
        )}
        <p>
          <strong>Amount:</strong> Rs. {encashment.amount}
        </p>
        <p>
          <strong>Status:</strong> {getStatusBadge(encashment.status)}
        </p>
        <p>
          <strong>Payment:</strong> {getPaymentBadge(encashment.paymentStatus)}
        </p>
        <p>
          <strong>Date:</strong>{" "}
          {new Date(encashment.createdAt).toLocaleDateString()}
        </p>
        {role === "admin" && (
          <p>
            <strong>Distributor:</strong>{" "}
            {encashment.distributor?.first_name}{" "}
            {encashment.distributor?.last_name} (
            {encashment.distributor?.email})
          </p>
        )}
      </Modal.Body>
      <Modal.Footer>
        {role === "admin" ? (
          <>
            <Button
              variant="success"
              disabled={loading || encashment.status === "Approved"}
              onClick={() => handleAction({ status: "Approved" })}
            >
              Approve
            </Button>
            <Button
              variant="danger"
              disabled={loading || encashment.status === "Rejected"}
              onClick={() => handleAction({ status: "Rejected" })}
            >
              Reject
            </Button>
            <Button
              variant="info"
              disabled={
                loading ||
                encashment.status !== "Approved" ||
                encashment.paymentStatus !== "Unpaid"
              }
              onClick={() => handleAction({ paymentStatus: "Processing" })}
            >
              Mark Processing
            </Button>
            <Button
              variant="primary"
              disabled={loading || encashment.status !== "Approved"}
              onClick={() => handleAction({ paymentStatus: "Paid" })}
            >
              Mark Paid
            </Button>
          </>
        ) : (
          encashment.status === "Pending" &&
          encashment.paymentStatus === "Unpaid" && (
            <Button
              variant="danger"
              disabled={loading}
              onClick={() => handleAction()}
            >
              Delete Request
            </Button>
          )
        )}
       
      </Modal.Footer>
    </Modal>
  );
}




// import React, { useState } from "react";
// import { Modal, Button, Badge } from "react-bootstrap";
// import API from "../../api/api";

// export default function EncashmentsModal({
//   show,
//   handleClose,
//   encashment,
//   role,
//   onSuccess,
// }) {
//   const [loading, setLoading] = useState(false);

//   const handleAction = async (updates) => {
//     try {
//       setLoading(true);
//       const url =
//         role === "admin"
//           ? `/api/encashments/admin/${encashment._id}`
//           : `/api/encashments/${encashment._id}`;

//       const method = role === "admin" ? "patch" : "delete";

//       if (method === "patch") {
//         await API.patch(url, updates, { withCredentials: true });
//       } else {
//         await API.delete(url, { withCredentials: true });
//       }

//       onSuccess();
//       handleClose();
//     } catch (err) {
//       console.error("Encashment action error:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getStatusBadge = (status) => {
//     const colors = {
//       Approved: "success",
//       Rejected: "danger",
//       Pending: "warning",
//     };
//     return <Badge bg={colors[status] || "secondary"}>{status}</Badge>;
//   };

//   const getPaymentBadge = (paymentStatus) => {
//     const colors = {
//       Paid: "primary",
//       Processing: "info",
//       Unpaid: "secondary",
//     };
//     return (
//       <Badge bg={colors[paymentStatus] || "secondary"}>{paymentStatus}</Badge>
//     );
//   };

//   return (
//     <Modal show={show} onHide={handleClose} centered>
//       <Modal.Header closeButton>
//         <Modal.Title>Encashment Details</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <p>
//           <strong>Amount:</strong> Rs. {encashment.amount}
//         </p>
//         <p>
//           <strong>Status:</strong> {getStatusBadge(encashment.status)}
//         </p>
//         <p>
//           <strong>Payment:</strong> {getPaymentBadge(encashment.paymentStatus)}
//         </p>
//         <p>
//           <strong>Date:</strong>{" "}
//           {new Date(encashment.createdAt).toLocaleDateString()}
//         </p>
//         {role === "admin" && (
//           <p>
//             <strong>Distributor:</strong> {encashment.distributor?.first_name}{" "}
//             {encashment.distributor?.last_name} ({encashment.distributor?.email}
//             )
//           </p>
//         )}
//       </Modal.Body>
//       <Modal.Footer>
//         {role === "admin" ? (
//           <>
//             <Button
//               variant="success"
//               disabled={loading}
//               onClick={() => handleAction({ status: "Approved" })}
//             >
//               Approve
//             </Button>
//             <Button
//               variant="danger"
//               disabled={loading}
//               onClick={() => handleAction({ status: "Rejected" })}
//             >
//               Reject
//             </Button>
//             <Button
//               variant="primary"
//               disabled={loading}
//               onClick={() => handleAction({ paymentStatus: "Paid" })}
//             >
//               Mark Paid
//             </Button>
//           </>
//         ) : (
//           encashment.status === "Pending" &&
//           encashment.paymentStatus === "Unpaid" && (
//             <Button
//               variant="danger"
//               disabled={loading}
//               onClick={() => handleAction()}
//             >
//               Delete Request
//             </Button>
//           )
//         )}
//         <Button variant="secondary" onClick={handleClose}>
//           Close
//         </Button>
//       </Modal.Footer>
//     </Modal>
//   );
// }
